import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/main/home'
import List from '@/components/main/list'
import Lable from '@/components/main/lable'
import Login from '@/components/main/login'
import User from '@/components/main/user'
import Add from '@/components/main/add'
import Test from '@/components/main/test'
import Zhibob from '@/components/main/zhibob'

import Homef from '@/components/main/homef'
import Lists from '@/components/main/lists'
import Listf from '@/components/main/listf'
import Lablef from '@/components/main/lablef'
import Addf from '@/components/main/addf'
import Testf from '@/components/main/testf'
import Renlian from '@/components/main/renlian'
import Ac from '@/components/main/ac'
import Acbao from '@/components/main/Acbao'
import Acst from '@/components/main/acst'
import Acstb from '@/components/main/acstb'
import nAc from '@/components/main/nac'
import nAcbao from '@/components/main/nAcbao'
import nAcst from '@/components/main/nacst'
import nAcstb from '@/components/main/nacstb'
import Tj from '@/components/main/tj'
import Tz from '@/components/main/tz'
import Key from '@/components/main/key'
import Arkey from '@/components/main/arkey'
import Nkey from '@/components/main/nkey'
import Keyself from '@/components/main/keyself'
import Arkeyself from '@/components/main/arkeyself'
import Nkeyself from '@/components/main/nkeyself'
import Keys from '@/components/main/keys'
import Keyo from '@/components/main/keyo'
import Arkeyo from '@/components/main/arkeyo'
import Nkeyo from '@/components/main/nkeyo'
import Ai from '@/components/main/ai'
import Arai from '@/components/main/arai'
import Nai from '@/components/main/nai'
import Dz from '@/components/main/dz'
import Ob from '@/components/main/orderby'
import Tui from '@/components/main/tui'
import Tuic from '@/components/main/tuic'
import MuBiao from '@/components/main/mubiao'
import MuBiaoK from '@/components/main/mubiaok'
import MuBiaoKt from '@/components/main/mubiaokt'
import MuBiaoo from '@/components/main/mubiaoo'
import MuBiaot from '@/components/main/mubiaot'
import MuBiaoKo from '@/components/main/mubiaoko'
import ArmuBiao from '@/components/main/armubiao'
import ArmuBiaoK from '@/components/main/armubiaok'
import ArmuBiaot from '@/components/main/armubiaot'
import ArmuBiaoKt from '@/components/main/armubiaokt'
import ArmuBiaoo from '@/components/main/armubiaoo'
import ArmuBiaoKo from '@/components/main/armubiaoko'
import NmuBiao from '@/components/main/nmubiao'
import NmuBiaoK from '@/components/main/nmubiaok'
import NmuBiaoo from '@/components/main/nmubiaoo'
import NmuBiaoKo from '@/components/main/nmubiaoko'
import Tiao from '@/components/main/tiao'
import Artiaotwo from '@/components/main/artiaotwo'
import TiaoTwo from '@/components/main/tiaotwo'
import Tiaow from '@/components/main/tiaow'
import Artiaow from '@/components/main/artiaow'
import Tiaowt from '@/components/main/tiaowt'
import Artiaowt from '@/components/main/artiaowt'
import Tiaowtt from '@/components/main/tiaowtt'
import Artiaowtt from '@/components/main/artiaowtt'
import Artiao from '@/components/main/artiao'
import Ntiao from '@/components/main/ntiao'
import Upload from '@/components/main/upload'
import Image from '@/components/main/image'
import ImageX from '@/components/main/imagex'
import ImageT from '@/components/main/imaget'
import STui from '@/components/main/stui'
import STime from '@/components/main/stime'
import Comge from '@/components/main/comge'
import Comgf from '@/components/main/comgf'
import Acg from '@/components/main/acg'
import Nacg from '@/components/main/nacg'
import Acb from '@/components/main/acb'
import Act from '@/components/main/act'
import Ach from '@/components/main/ach'
import Acj from '@/components/main/acj'
import Quanqiuyoulan from '@/components/main/quanqiuyoulan'
import Kuaidi from '@/components/main/kuaidi'
import Elementsh from '@/components/main/elementsh'
import Elementshyb from '@/components/main/elementshyb'
import Elementshneibu from '@/components/main/elementshneibu'
import Elementshbiaoshi from '@/components/main/elementshbiaoshi'
import Elementshcp from '@/components/main/elementshcp'
import Elementshcpj from '@/components/main/elementshcpj'
import Elementshsb from '@/components/main/elementshsb'
import Elementshtf from '@/components/main/elementshtf'
import Elementshjz from '@/components/main/elementshjz'
import Elementshdq from '@/components/main/elementshdq'
import Elementsssb from '@/components/main/elementsssb'
import Elementssdq from '@/components/main/elementssdq'
import Elementzx from '@/components/main/elementzx'
import Elementzxdq from '@/components/main/elementzxdq'
import Elementfx from '@/components/main/elementfx'
import Elementfxsb from '@/components/main/elementfxsb'
import Elementzxs from '@/components/main/elementzxs'
import Elementfxs from '@/components/main/elementfxs'
import Elementlx from '@/components/main/elementlx'
import Elementlxs from '@/components/main/elementlxs'
import Elementdt from '@/components/main/elementdt'
import Elementdtb from '@/components/main/elementdtb'
import Elementdtsb from '@/components/main/elementdtsb'
import Elementdttui from '@/components/main/elementdttui'
import Elementdtl from '@/components/main/elementdtl'
import Elementdts from '@/components/main/elementdts'
import Ceshi from '@/components/main/ceshi'
import Ciku from '@/components/main/Ciku'
import Shipin from '@/components/main/shipin'
import Snews from '@/components/main/snews'
import Smusic from '@/components/main/smusic'
import Smusicyinpin from '@/components/main/smusicyinpin'
import Sgood from '@/components/main/sgood'
import Sbaike from '@/components/main/sbaike'
import Wangzhi from '@/components/main/wangzhi'
import Wangzhis from '@/components/main/wangzhis'
import Wangzhig from '@/components/main/wangzhig'
import Equipment from '@/components/main/equipment'
import Equipmentc from '@/components/main/equipmentc'
import Equipmentcf from '@/components/main/equipmentcf'
import Equipmentck from '@/components/main/equipmentck'
import Equipmentx from '@/components/main/equipmentx'
import Equipmentxf from '@/components/main/equipmentxf'
import Equipmentxk from '@/components/main/equipmentxk'
import Equipmentz from '@/components/main/equipmentz'
import Equipmentzf from '@/components/main/equipmentzf'
import Equipmentzk from '@/components/main/equipmentzk'
import Equipmentw from '@/components/main/equipmentw'
import Xianliurc from '@/components/main/xianliurc'
import Xianliuch from '@/components/main/xianliuch'
import Xianliucc from '@/components/main/xianliucc'
import Xianliux from '@/components/main/xianliux'
import Xianliurcd from '@/components/main/xianliurcd'
import Xianliuxd from '@/components/main/xianliuxd'
import Aexcel from '@/components/main/aexcel'
import Xexcel from '@/components/main/xexcel'
import Gexcel from '@/components/main/gexcel'
import G2excel from '@/components/main/g2excel'
import Kexcel from '@/components/main/kexcel'
import Sexcel from '@/components/main/sexcel'
import Wexcel from '@/components/main/wexcel'
import Zglexcel from '@/components/main/zglexcel'
import Gnglexcel from '@/components/main/gnglexcel'
import Selfexcel from '@/components/main/selfexcel'
import Seach from '@/components/main/seach'
import Qianming from '@/components/main/qianming'
import Nseach from '@/components/main/nseach'
import Gtell from '@/components/main/gtell'
import Gmsg from '@/components/main/gmsg'
import Gapp from '@/components/main/gapp'
import Goodtui from '@/components/main/goodtui'
import Wangzhitui from '@/components/main/wangzhitui'
import Dibiaotui from '@/components/main/dibiaotui'
import Arstate from '@/components/main/arstate'
import Youxi from '@/components/main/youxi'
import Youxitui from '@/components/main/youxitui'
import Acimg from '@/components/main/acimg'
import Acimgm from '@/components/main/acimgm'
import Qw from '@/components/main/qw'
import Qa from '@/components/main/qa'
import Qadata from '@/components/main/qadata'
import Qxdata from '@/components/main/qxdata'
import Qwdata from '@/components/main/qwdata'
import Qx from '@/components/main/qx'
import Qswicth from '@/components/main/qswicth'
import Qwax from '@/components/main/qwax'
import Qwaxd from '@/components/main/qwaxd'
import ElementUp from '@/components/main/elementUp'
import Fxweizhi from '@/components/main/fxweizhi'
import Fxdingwei from '@/components/main/fxdingwei'
import Fxzhibo from '@/components/main/fxzhibo'
import Wendang from '@/components/main/wendang'
import Talk from '@/components/main/talk'
import Elementhuanrao from '@/components/main/elementhuanrao'
import Redisdata from '@/components/main/redisdata'
import Qredis from '@/components/main/qredis'
import Qsredis from '@/components/main/qsredis'
import Wzuobiao from '@/components/main/wzuobiao'
import Wmanhua from '@/components/main/wmanhua'
import Whetong from '@/components/main/whetong'
import Wdaolan from '@/components/main/wdaolan'
import Wneibu from '@/components/main/wneibu'
import Wzhibo from '@/components/main/wzhibo'
import Sduowei from '@/components/main/sduowei'
import Gtells from '@/components/main/gtells'
import Qxtdata from '@/components/main/qxtdata'
import Qwtdata from '@/components/main/qwtdata'
import Qatdata from '@/components/main/qatdata'
import Wshangr from '@/components/main/wshangr'
import Wshangd from '@/components/main/wshangd'
import Qredisup from '@/components/main/qredisup'
import Open from '@/components/main/open'
import Yuzhouyingshe from '@/components/main/yuzhouyingshe'
import Yuzhoutiankong from '@/components/main/yuzhoutiankong'
import Fayinren from '@/components/main/fayinren'
import Alearn from '@/components/main/alearn'
import Yuzhouhx from '@/components/main/yuzhouhx'
import Yuzhouth from '@/components/main/yuzhouth'
import Yjiangjie from '@/components/main/yjiangjie'
import Yjiangjiem from '@/components/main/yjiangjiem'
import Yjiangjie156 from '@/components/main/yjiangjie156'
import Yjiangjiem156 from '@/components/main/yjiangjiem156'
import Yjiangjie163 from '@/components/main/yjiangjie163'
import Yjiangjiem163 from '@/components/main/yjiangjiem163'
import Aasystem from '@/components/main/aasystem'
import Gapps from '@/components/main/gapps'
import Yzkjshipei from '@/components/main/yzkjshipei'
import Zhuchi from '@/components/main/zhuchi'
import Yuzhouys from '@/components/main/yuzhouys'
import Yuzhoumk from '@/components/main/yuzhoumk'
import Yquanwei from '@/components/main/yquanwei'
import Yquanweim from '@/components/main/yquanweim'
import Yuzhoujk from '@/components/main/yuzhoujk'
import Yuzhoujc from '@/components/main/yuzhoujc'
import Yuzhouzk from '@/components/main/yuzhouzk'
import Yuzhousq from '@/components/main/yuzhousq'
import Ards from '@/components/main/ards'
import Abzhankaiyzkj from '@/components/main/abzhankaiyzkj'
import Abguanbiyzkj from '@/components/main/abguanbiyzkj'
import Abxuanzeyzww from '@/components/main/abxuanzeyzww'
import Elementshsw from '@/components/main/elementshsw'
import Elementshcj from '@/components/main/elementshcj'
import Sanl28 from '@/components/main/sanl28'
import Wangzhik from '@/components/main/wangzhik'
import Openz from '@/components/main/openz'
import Gtellg from '@/components/main/gtellg'

import Wangzhi134 from '@/components/main/wangzhi134'
import Wangzhi135 from '@/components/main/wangzhi135'
import Wangzhi136 from '@/components/main/wangzhi136'
import Wangzhi137 from '@/components/main/wangzhi137'
import Appidceng from '@/components/main/appidceng'
import Open138 from '@/components/main/open138'
import Open155 from '@/components/main/open155'
import Open162 from '@/components/main/open162'
import Wangzhi139 from '@/components/main/wangzhi139'
import Wangzhi140 from '@/components/main/wangzhi140'
import Wangzhi141 from '@/components/main/wangzhi141'
import Wangzhi142 from '@/components/main/wangzhi142'
import Wangzhi143 from '@/components/main/wangzhi143'
import Appiddou from '@/components/main/appiddou'

import Wangzhi144 from '@/components/main/wangzhi144'
import Wangzhi145 from '@/components/main/wangzhi145'
import Wangzhi146 from '@/components/main/wangzhi146'
import Wangzhi147 from '@/components/main/wangzhi147'

import Wangzhi148 from '@/components/main/wangzhi148'
import Wangzhi149 from '@/components/main/wangzhi149'
import Wangzhi150 from '@/components/main/wangzhi150'
import Wangzhi151 from '@/components/main/wangzhi151'

import Wangzhi152 from '@/components/main/wangzhi152'
import Wangzhi153 from '@/components/main/wangzhi153'
import Wangzhi154 from '@/components/main/wangzhi154'
import Wangzhi400 from '@/components/main/wangzhi400'

import Wangzhi157 from '@/components/main/wangzhi157'
import Wangzhi158 from '@/components/main/wangzhi158'
import Wangzhi159 from '@/components/main/wangzhi159'
import Wangzhi160 from '@/components/main/Wangzhi160'
import Wangzhi164 from '@/components/main/Wangzhi164'
import Wangzhi190 from '@/components/main/Wangzhi190'
import Wangzhi191 from '@/components/main/Wangzhi191'

import Richang from '@/components/main/richang'
import Richanglist from '@/components/main/richanglist'

import Yingbincard from '@/components/main/yingbincard'
import Yingbinrenlian from '@/components/main/yingbinrenlian'
import Yingbinchepai from '@/components/main/yingbinchepai'

import Appidzhiye from '@/components/main/appidzhiye'
import Appidtuijian from '@/components/main/appidtuijian'

import Bshangpin from '@/components/main/bshangpin'
import Byjiudian from '@/components/main/byjiudian'

import Byxiaoqu from '@/components/main/byxiaoqu'
import Byyuanqu from '@/components/main/byyuanqu'
import Byxiezilou from '@/components/main/byxiezilou'


import Byxiaoqu1 from '@/components/main/byxiaoqu1'
import Byyuanqu1 from '@/components/main/byyuanqu1'
import Byxiezilou1 from '@/components/main/byxiezilou1'


import Byqiye from '@/components/main/byqiye'
import Bychangqu from '@/components/main/bychangqu'
import Byshangchang from '@/components/main/byshangchang'
import Bylaobaixing from '@/components/main/bylaobaixing'

import Byqiye1 from '@/components/main/byqiye1'
import Bychangqu1 from '@/components/main/bychangqu1'
import Byshangchang1 from '@/components/main/byshangchang1'
import Tongyong from '@/components/main/tongyong'
import Aone from '@/components/main/aone'

import Mianshi from '@/components/main/mianshi'
import Mianshim from '@/components/main/mianshim'
import Mianshilist from '@/components/main/mianshilist'
import Mianshilists from '@/components/main/mianshilists'

import Grichang from '@/components/main/grichang'
import Grichanglist from '@/components/main/grichanglist'

import Ggrichang from '@/components/main/ggrichang'
import Ggaorichanglist from '@/components/main/ggaorichanglist'

import Xingxiang from '@/components/main/xingxiang'
import Xingxiangww from '@/components/main/xingxiangww'
import Xingxiangz from '@/components/main/xingxiangz'
import Xingxiangm from '@/components/main/xingxiangm'
import XingxiangAction from '@/components/main/xingxiangAction'
import XingxiangActionList from '@/components/main/XingxiangActionList'
import PrivateUniverseOwnedItem from '@/components/main/privateUniverseOwnedItem'
import PrivateUniverseTypeProduct from '@/components/main/privateUniverseTypeProduct'
import Dongwu from '@/components/main/dongwu'
import Dongwum from '@/components/main/dongwum'
import Jiaobiao from '@/components/main/jiaobiao'

import Yzzmbt from '@/components/main/yzzmbt'

import Xingqiu from '@/components/main/xingqiu'
import Xingqiuz from '@/components/main/xingqiuz'

import Xingqiuyz from '@/components/main/xingqiuyz'
import Xingqiuyzz from '@/components/main/xingqiuyzz'

import Xingqiukj from '@/components/main/xingqiukj'
import Xingqiukjz from '@/components/main/xingqiukjz'

import Xingxiangawz from '@/components/main/xingxiangawz'
import Xingxiangawzz from '@/components/main/xingxiangawzz'
import Xingxiangyuzhou from '@/components/main/xingxiangyuzhou'
import Xingxiangyuzhouz from '@/components/main/xingxiangyuzhouz'
import Xingxiangzhimi from '@/components/main/xingxiangzhimi'
import Xingxiangzhimiz from '@/components/main/xingxiangzhimiz'
import Xingxiangwuxian from '@/components/main/xingxiangwuxian'
import Xingxiangwuxianz from '@/components/main/xingxiangwuxianz'
import Tongji from '@/components/main/aatongji'
import TongjiProgress from '@/components/main/aatongjiProgress'
import TongjiProgressnew from '@/components/main/aatongjiProgressnew'
import TongjiCategory from '@/components/main/aatongjiCategory'
import TongjiCategoryDetail from '@/components/main/aatongjiCategoryDetail'
import TongjiPerception from '@/components/main/aatongjiPerception'
import TongjiPerceptionDetail from '@/components/main/aatongjiPerceptionDetail'
import Base from '@/components/main/base'
import AppVersion from '@/components/main/appVersion'

import Ganjue from '@/components/main/ganjue'
import Ganjues from '@/components/main/ganjues'
Vue.use(Router)

export default new Router({
  mode: 'history',
  bash: '/',
  routes: [
    {
      path: '/',
      component: Login
    },
	{
	  path: '/tongji',
	  name: 'Tongji',
	  component: Tongji
	},
	{
	  path: '/tongjiprogressnew',
	  name: 'TongjiProgressnew',
	  component: TongjiProgressnew
	},
	{
	  path: '/tongjiprogress',
	  name: 'TongjiProgress',
	  component: TongjiProgress
	},
	{
	  path: '/tongjicategory',
	  name: 'TongjiCategory',
	  component: TongjiCategory
	},
	{
	  path: '/tongjicategorydetail',
	  name: 'TongjiCategoryDetail',
	  component: TongjiCategoryDetail
	},
	{
	  path: '/tongjiperception',
	  name: 'TongjiPerception',
	  component: TongjiPerception
	},
	{
	  path: '/tongjiperceptiondetail',
	  name: 'TongjiPerceptionDetail',
	  component: TongjiPerceptionDetail
	},
	{
	  path: '/ganjue',
	  name: 'Ganjue',
	  component: Ganjue
	},
	{
	  path: '/ganjues',
	  name: 'Ganjues',
	  component: Ganjues
	},
  {
	  path: '/xingxiangawz',
	  name: 'Xingxiangawz',
	  component: Xingxiangawz
	},
  {
    path: '/xingxiangawzz',
	  name: 'Xingxiangawzz',
	  component: Xingxiangawzz
  },
  {
    path: '/xingxiangyuzhou',
	  name: 'Xingxiangyuzhou',
	  component: Xingxiangyuzhou
  },
  {
    path: '/xingxiangyuzhouz',
	  name: 'Xingxiangyuzhouz',
	  component: Xingxiangyuzhouz
  },
  {
    path: '/xingxiangzhimi',
	  name: 'Xingxiangzhimi',
	  component: Xingxiangzhimi
  },
  {
    path: '/xingxiangzhimiz',
	  name: 'Xingxiangzhimiz',
	  component: Xingxiangzhimiz
  },
  {
    path: '/xingxiangwuxian',
	  name: 'Xingxiangwuxian',
	  component: Xingxiangwuxian
  },
  {
    path: '/xingxiangwuxianz',
	  name: 'Xingxiangwuxianz',
	  component: Xingxiangwuxianz
  },
  
	{
	  path: '/base',
	  name: 'Base',
	  component: Base
	},
	{
	  path: '/app-version',
	  name: 'AppVersion',
	  component: AppVersion
	},
	{
	  path: '/xingxiangww',
	  name: 'Xingxiangww',
	  component: Xingxiangww
	},
		{
		  path: '/xingqiukj',
		  name: 'Xingqiukj',
		  component: Xingqiukj
		},
		{
		  path: '/xingqiukjz',
		  name: 'Xingqiukjz',
		  component: Xingqiukjz
		},
		{
		  path: '/xingqiu',
		  name: 'Xingqiu',
		  component: Xingqiu
		},
		{
		  path: '/xingqiuz',
		  name: 'Xingqiuz',
		  component: Xingqiuz
		},
		{
		  path: '/xingqiuyz',
		  name: 'Xingqiuyz',
		  component: Xingqiuyz
		},
		{
		  path: '/xingqiuyzz',
		  name: 'Xingqiuyzz',
		  component: Xingqiuyzz
		},
		{
		  path: '/yzzmbt',
		  name: 'Yzzmbt',
		  component: Yzzmbt
		},
		{
		  path: '/jiaobiao',
		  name: 'Jiaobiao',
		  component: Jiaobiao
		},
		{
		  path: '/dongwu',
		  name: 'Dongwu',
		  component: Dongwu
		},
		{
		  path: '/dongwum',
		  name: 'Dongwum',
		  component: Dongwum
		},
		{
		  path: '/xingxiang',
		  name: 'Xingxiang',
		  component: Xingxiang
		},
		{
		  path: '/xingxiangz',
		  name: 'Xingxiangz',
		  component: Xingxiangz
		},
		{
		  path: '/xingxiangm',
		  name: 'Xingxiangm',
		  component: Xingxiangm
		},
		{
		  path: '/xingxiang-action-list',
          name: 'XingxiangActionList',
          component: XingxiangActionList
        },
        {
          path: '/xingxiangAction',
		  name: 'XingxiangAction',
		  component: XingxiangAction
		},
		{
		  path: '/private-universe-owned-item',
		  name: 'PrivateUniverseOwnedItem',
		  component: PrivateUniverseOwnedItem
		},
		{
		  path: '/private-universe-type-product',
		  name: 'PrivateUniverseTypeProduct',
		  component: PrivateUniverseTypeProduct
		},
		{
		  path: '/ggaorichanglist',
		  name: 'Ggaorichanglist',
		  component: Ggaorichanglist
		},
		{
		  path: '/ggrichang',
		  name: 'Ggrichang',
		  component: Ggrichang
		},
		{
		  path: '/grichanglist',
		  name: 'Grichanglist',
		  component: Grichanglist
		},
		{
		  path: '/grichang',
		  name: 'Grichang',
		  component: Grichang
		},
		{
		  path: '/mianshilists',
		  name: 'Mianshilists',
		  component: Mianshilists
		},
		{
		  path: '/mianshilist',
		  name: 'Mianshilist',
		  component: Mianshilist
		},
		{
		  path: '/mianshim',
		  name: 'Mianshim',
		  component: Mianshim
		},
		{
		  path: '/mianshi',
		  name: 'Mianshi',
		  component: Mianshi
		},
		{
		  path: '/tongyong',
		  name: 'Tongyong',
		  component: Tongyong
		},
		{
		  path: '/aone',
		  name: 'Aone',
		  component: Aone
		},
	{
	  path: '/appidtuijian',
	  name: 'Appidtuijian',
	  component: Appidtuijian
	},
	{
	  path: '/bshangpin',
	  name: 'Bshangpin',
	  component: Bshangpin
	},
	{
	  path: '/byjiudian',
	  name: 'Byjiudian',
	  component: Byjiudian
	},
	
	{
	  path: '/byxiaoqu',
	  name: 'Byxiaoqu',
	  component: Byxiaoqu
	},
	{
	  path: '/byyuanqu',
	  name: 'Byyuanqu',
	  component: Byyuanqu
	},
	{
	  path: '/byxiezilou',
	  name: 'Byxiezilou',
	  component: Byxiezilou
	},
	{
	  path: '/byxiaoqu1',
	  name: 'Byxiaoqu1',
	  component: Byxiaoqu1
	},
	{
	  path: '/byyuanqu1',
	  name: 'Byyuanqu1',
	  component: Byyuanqu1
	},
	{
	  path: '/byxiezilou1',
	  name: 'Byxiezilou1',
	  component: Byxiezilou1
	},
		
		
	{
	  path: '/byqiye',
	  name: 'Byqiye',
	  component: Byqiye
	},	
	{
	  path: '/bychangqu',
	  name: 'Bychangqu',
	  component: Bychangqu
	},
	{
	  path: '/byshangchang',
	  name: 'Byshangchang',
	  component: Byshangchang
	},
	{
	  path: '/bylaobaixing',
	  name: 'Bylaobaixing',
	  component: Bylaobaixing
	},	
		
	{
	  path: '/byqiye1',
	  name: 'Byqiye1',
	  component: Byqiye1
	},	
	{
	  path: '/bychangqu1',
	  name: 'Bychangqu1',
	  component: Bychangqu1
	},
	{
	  path: '/byshangchang1',
	  name: 'Byshangchang1',
	  component: Byshangchang1
	},
		
		{
		  path: '/richanglist',
		  name: 'Richanglist',
		  component: Richanglist
		},
		{
		  path: '/richang',
		  name: 'Richang',
		  component: Richang
		},
	{
	  path: '/yingbincard',
	  name: 'Yingbincard',
	  component: Yingbincard
	},
	{
	  path: '/appidzhiye',
	  name: 'Appidzhiye',
	  component: Appidzhiye
	},
	{
	  path: '/yingbinrenlian',
	  name: 'Yingbinrenlian',
	  component: Yingbinrenlian
	},
	{
	  path: '/yingbinchepai',
	  name: 'Yingbinchepai',
	  component: Yingbinchepai
	},
    {
      path: '/zhibob',
      name: 'Zhibob',
      component: Zhibob
    },
    {
      path: '/renlian',
      name: 'Renlian',
      component: Renlian
    },
    {
      path: '/wangzhi157',
      name: 'Wangzhi157',
      component: Wangzhi157
    },
    {
      path: '/wangzhi158',
      name: 'Wangzhi158',
      component: Wangzhi158
    },
    {
      path: '/wangzhi159',
      name: 'Wangzhi159',
      component: Wangzhi159
    },
    {
      path: '/wangzhi160',
      name: 'Wangzhi160',
      component: Wangzhi160
    },
		{
		  path: '/wangzhi190',
		  name: 'Wangzhi190',
		  component: Wangzhi190
		},
		{
		  path: '/wangzhi191',
		  name: 'Wangzhi191',
		  component: Wangzhi191
		},
    {
      path: '/wangzhi164',
      name: 'Wangzhi164',
      component: Wangzhi164
    },
    {
      path: '/wangzhi400',
      name: 'Wangzhi400',
      component: Wangzhi400
    },
    {
      path: '/wangzhi152',
      name: 'Wangzhi152',
      component: Wangzhi152
    },
    {
      path: '/wangzhi153',
      name: 'Wangzhi153',
      component: Wangzhi153
    },
    {
      path: '/wangzhi154',
      name: 'Wangzhi154',
      component: Wangzhi154
    },
    {
      path: '/wangzhi148',
      name: 'Wangzhi148',
      component: Wangzhi148
    },
    {
      path: '/wangzhi149',
      name: 'Wangzhi149',
      component: Wangzhi149
    },
    {
      path: '/wangzhi150',
      name: 'Wangzhi150',
      component: Wangzhi150
    },
    {
      path: '/wangzhi151',
      name: 'Wangzhi151',
      component: Wangzhi151
    },
    {
      path: '/wangzhi144',
      name: 'Wangzhi144',
      component: Wangzhi144
    },
    {
      path: '/wangzhi145',
      name: 'Wangzhi145',
      component: Wangzhi145
    },
    {
      path: '/wangzhi146',
      name: 'Wangzhi146',
      component: Wangzhi146
    },
    {
      path: '/wangzhi147',
      name: 'Wangzhi147',
      component: Wangzhi147
    },
    {
      path: '/appiddou',
      name: 'Appiddou',
      component: Appiddou
    },
    {
      path: '/wangzhi139',
      name: 'Wangzhi139',
      component: Wangzhi139
    },
    {
      path: '/wangzhi140',
      name: 'Wangzhi140',
      component: Wangzhi140
    },
    {
      path: '/wangzhi141',
      name: 'Wangzhi141',
      component: Wangzhi141
    },
    {
      path: '/wangzhi142',
      name: 'Wangzhi142',
      component: Wangzhi142
    },
    {
      path: '/wangzhi143',
      name: 'Wangzhi143',
      component: Wangzhi143
    },
    {
      path: '/open138',
      name: 'Open138',
      component: Open138
    },
    {
      path: '/open155',
      name: 'Open155',
      component: Open155
    },
    {
      path: '/open162',
      name: 'Open162',
      component: Open162
    },
    {
      path: '/appidceng',
      name: 'Appidceng',
      component: Appidceng
    },
    {
      path: '/wangzhi134',
      name: 'Wangzhi134',
      component: Wangzhi134
    },
    {
      path: '/wangzhi135',
      name: 'Wangzhi135',
      component: Wangzhi135
    },
    {
      path: '/wangzhi136',
      name: 'Wangzhi136',
      component: Wangzhi136
    },
    {
      path: '/wangzhi137',
      name: 'Wangzhi137',
      component: Wangzhi137
    },
    {
      path: '/wangzhik',
      name: 'Wangzhik',
      component: Wangzhik
    },
    {
      path: '/openz',
      name: 'Openz',
      component: Openz
    },
    {
      path: '/gtellg',
      name: 'Gtellg',
      component: Gtellg
    },
    {
      path: '/sanl28',
      name: 'Sanl28',
      component: Sanl28
    },
    {
      path: '/homef',
      name: 'Homef',
      component: Homef
    },
    {
      path: '/listf',
      name: 'Listf',
      component: Listf
    },
    {
      path: '/lists',
      name: 'Lists',
      component: Lists
    },
    {
      path: '/lablef',
      name: 'Lablef',
      component: Lablef
    },
    {
      path: '/addf',
      name: 'Addf',
      component: Addf
    },
    {
      path: '/testf',
      name: 'Testf',
      component: Testf
    },
    {
      path: '/elementshsw',
      name: 'Elementshsw',
      component: Elementshsw
    },
    {
      path: '/elementshcj',
      name: 'Elementshcj',
      component: Elementshcj
    },
    {
      path: '/abzhankaiyzkj',
      name: 'Abzhankaiyzkj',
      component: Abzhankaiyzkj
    },
    {
      path: '/abguanbiyzkj',
      name: 'Abguanbiyzkj',
      component: Abguanbiyzkj
    },
    {
      path: '/abxuanzeyzww',
      name: 'Abxuanzeyzww',
      component: Abxuanzeyzww
    },
    {
      path: '/ards',
      name: 'Ards',
      component: Ards
    },
    {
      path: '/yuzhouzk',
      name: 'Yuzhouzk',
      component: Yuzhouzk
    },
    {
      path: '/yuzhousq',
      name: 'Yuzhousq',
      component: Yuzhousq
    },
    {
      path: '/yuzhoujc',
      name: 'Yuzhoujc',
      component: Yuzhoujc
    },
    {
      path: '/yuzhoujk',
      name: 'Yuzhoujk',
      component: Yuzhoujk
    },
    {
      path: '/yquanwei',
      name: 'Yquanwei',
      component: Yquanwei
    },
    {
      path: '/yquanweim',
      name: 'Yquanweim',
      component: Yquanweim
    },
    {
      path: '/yuzhoumk',
      name: 'Yuzhoumk',
      component: Yuzhoumk
    },
    {
      path: '/yuzhouys',
      name: 'Yuzhouys',
      component: Yuzhouys
    },
    {
      path: '/zhuchi',
      name: 'Zhuchi',
      component: Zhuchi
    },
    {
      path: '/gapps',
      name: 'Gapps',
      component: Gapps
    },
    {
      path: '/yzkjshipei',
      name: 'Yzkjshipei',
      component: Yzkjshipei
    },
    {
      path: '/aasystem',
      name: 'Aasystem',
      component: Aasystem
    },
    {
      path: '/alearn',
      name: 'Alearn',
      component: Alearn
    },
    {
      path: '/yjiangjie',
      name: 'Yjiangjie',
      component: Yjiangjie
    },
    {
      path: '/yjiangjiem',
      name: 'Yjiangjiem',
      component: Yjiangjiem
    },
    {
      path: '/yjiangjie156',
      name: 'Yjiangjie156',
      component: Yjiangjie156
    },
    {
      path: '/yjiangjiem156',
      name: 'Yjiangjiem156',
      component: Yjiangjiem156
    },
    {
      path: '/yjiangjie163',
      name: 'Yjiangjie163',
      component: Yjiangjie163
    },
    {
      path: '/yjiangjiem163',
      name: 'Yjiangjiem163',
      component: Yjiangjiem163
    },
    {
      path: '/yuzhouth',
      name: 'Yuzhouth',
      component: Yuzhouth
    },
    {
      path: '/yuzhouhx',
      name: 'Yuzhouhx',
      component: Yuzhouhx
    },
    {
      path: '/fayinren',
      name: 'Fayinren',
      component: Fayinren
    },
    {
      path: '/yuzhouyingshe',
      name: 'Yuzhouyingshe',
      component: Yuzhouyingshe
    },
    {
      path: '/yuzhoutiankong',
      name: 'Yuzhoutiankong',
      component: Yuzhoutiankong
    },
    {
      path: '/qredisup',
      name: 'Qredisup',
      component: Qredisup
    },
	{
	  path: '/open',
	  name: 'Open',
	  component: Open
	},
	{
	   path: '/wshangr',
	   name: 'Wshangr',
	   component: Wshangr
	 },
	 {
	   path: '/wshangd',
	   name: 'Wshangd',
	   component: Wshangd
	 },
	 {
	   path: '/qatdata',
	   name: 'Qatdata',
	   component: Qatdata
	 },
	 {
	   path: '/qwtdata',
	   name: 'Qwtdata',
	   component: Qwtdata
	 },
	 {
	   path: '/qxtdata',
	   name: 'Qxtdata',
	   component: Qxtdata
	 },
	 {
	   path: '/gtells',
	   name: 'Gtells',
	   component: Gtells
	 },
	 {
	   path: '/sduowei',
	   name: 'Sduowei',
	   component: Sduowei
	 },
	{
	  path: '/wmanhua',
	  name: 'Wmanhua',
	  component: Wmanhua
	},
	{
	  path: '/whetong',
	  name: 'Whetong',
	  component: Whetong
	},
	{
	  path: '/wzuobiao',
	  name: 'Wzuobiao',
	  component: Wzuobiao
	},
	{
	  path: '/wdaolan',
	  name: 'Wdaolan',
	  component: Wdaolan
	},
	{
	  path: '/wneibu',
	  name: 'Wneibu',
	  component: Wneibu
	},
	{
	  path: '/wzhibo',
	  name: 'Wzhibo',
	  component: Wzhibo
	},
    {
      path: '/redisdata',
      name: 'Redisdata',
      component: Redisdata
    },
    {
      path: '/qredis',
      name: 'Qredis',
      component: Qredis
    },
    {
      path: '/qsredis',
      name: 'Qsredis',
      component: Qsredis
    },
    {
      path: '/elementUp',
      name: 'ElementUp',
      component: ElementUp
    },
    {
      path: '/talk',
      name: 'Talk',
      component: Talk
    },
    {
      path: '/elementhuanrao',
      name: 'Elementhuanrao',
      component: Elementhuanrao
    },
    {
      path: '/qwaxd',
      name: 'Qwaxd',
      meta:{'title':'1111111'},
      component: Qwaxd
    },
    {
      path: '/qwax',
      name: 'Qwax',
      component: Qwax
    },
    {
      path: '/qswicth',
      name: 'Qswicth',

      component: Qswicth
    },
    {
      path: '/qw',
      name: 'Qw',
      component: Qw
    },
    {
      path: '/qa',
      name: 'Qa',
      component: Qa
    },
    {
      path: '/qadata',
      name: 'Qadata',
      component: Qadata
    },
    {
      path: '/qwdata',
      name: 'Qwdata',
      component: Qwdata
    },
    {
      path: '/qx',
      name: 'Qx',
      component: Qx
    },
    {
      path: '/qxdata',
      name: 'Qxdata',
      component: Qxdata
    },
    {
      path: '/arstate',
      name: 'Arstate',
      component: Arstate
    },
    {
      path: '/acimg',
      name: 'Acimg',
      component: Acimg
    },
    {
      path: '/acimgm',
      name: 'Acimgm',
      component: Acimgm
    },
    {
      path: '/youxi',
      name: 'Youxi',
      component: Youxi
    },
    {
      path: '/youxitui',
      name: 'Youxitui',
      component: Youxitui
    },
    {
      path: '/dibiaotui',
      name: 'Dibiaotui',
      component: Dibiaotui
    },
    {
      path: '/goodtui',
      name: 'Goodtui',
      component: Goodtui
    },
    {
      path: '/wangzhitui',
      name: 'Wangzhitui',
      component: Wangzhitui
    },
    {
      path: '/gtell',
      name: 'Gtell',
      component: Gtell
    },
    {
      path: '/gapp',
      name: 'Gapp',
      component: Gapp
    },
    {
      path: '/gmsg',
      name: 'Gmsg',
      component: Gmsg
    },
    {
      path: '/zglexcel',
      name: 'Zglexcel',
      component: Zglexcel
    },
    {
      path: '/quanqiuyoulan',
      name: 'Quanqiuyoulan',
      component: Quanqiuyoulan
    },
    {
      path: '/ciku',
      name: 'Ciku',
      component: Ciku
    },
    {
      path: '/gnglexcel',
      name: 'Gnglexcel',
      component: Gnglexcel
    },
    {
      path: '/aexcel',
      name: 'Aexcel',
      component: Aexcel
    },
    {
      path: '/qianming',
      name: 'Qianming',
      component: Qianming
    },
    {
      path: '/xexcel',
      name: 'Xexcel',
      component: Xexcel
    },
    {
      path: '/seach',
      name: 'Seach',
      component: Seach
    },
    {
      path: '/nseach',
      name: 'Nseach',
      component: Nseach
    },
    {
      path: '/kexcel',
      name: 'Kexcel',
      component: Kexcel
    },
    {
      path: '/gexcel',
      name: 'Gexcel',
      component: Gexcel
    },
    {
      path: '/g2excel',
      name: 'G2excel',
      component: G2excel
    },
    {
      path: '/sexcel',
      name: 'Sexcel',
      component: Sexcel
    },
    {
      path: '/wexcel',
      name: 'Wexcel',
      component: Wexcel
    },
    {
      path: '/selfexcel',
      name: 'Selfexcel',
      component: Selfexcel
    },
    {
      path: '/xianliux',
      name: 'Xianliux',
      component: Xianliux
    },
    {
      path: '/xianliuxd',
      name: 'Xianliuxd',
      component: Xianliuxd
    },
    {
      path: '/xianliurc',
      name: 'Xianliurc',
      component: Xianliurc
    },
    {
      path: '/xianliurcd',
      name: 'Xianliurcd',
      component: Xianliurcd
    },
    {
      path: '/xianliuch',
      name: 'Xianliuch',
      component: Xianliuch
    },
    {
      path: '/xianliucc',
      name: 'Xianliucc',
      component: Xianliucc
    },
    {
      path: '/elementsh',
      name: 'Elementsh',
      component: Elementsh
    },
    {
      path: '/shipin',
      name: 'Shipin',
      component: Shipin
    },
	{
	  path: '/snews',
	  name: 'Snews',
	  component: Snews
	},
	{
	  path: '/smusic',
	  name: 'Smusic',
	  component: Smusic
	},
  {
    path: '/smusicyinpin',
    name: 'Smusicyinpin',
    component: Smusicyinpin
  },
  {
    path: '/sgood',
    name: 'Sgood',
    component: Sgood
  },
  {
    path: '/sbaike',
    name: 'Sbaike',
    component: Sbaike
  },
    {
      path: '/wangzhi',
      name: 'Wangzhi',
      component: Wangzhi
    },
    {
      path: '/wangzhis',
      name: 'Wangzhis',
      component: Wangzhis
    },
    {
      path: '/wangzhig',
      name: 'Wangzhig',
      component: Wangzhig
    },
    {
      path: '/act',
      name: 'Act',
      component: Act
    },
    {
      path: '/acst',
      name: 'Acst',
      component: Acst
    },
    {
      path: '/acstb',
      name: 'Acstb',
      component: Acstb
    },
    {
      path: '/nacst',
      name: 'nAcst',
      component: nAcst
    },
    {
      path: '/nacstb',
      name: 'nAcstb',
      component: nAcstb
    },
    {
      path: '/elementshyb',
      name: 'Elementshyb',
      component: Elementshyb
    },
    {
      path: '/elementshneibu',
      name: 'Elementshneibu',
      component: Elementshneibu
    },
    {
      path: '/elementshbiaoshi',
      name: 'Elementshbiaoshi',
      component: Elementshbiaoshi
    },
	{
	  path: '/kuaidi',
	  name: 'Kuaidi',
	  component: Kuaidi
	},
    {
      path: '/elementshcp',
      name: 'Elementshcp',
      component: Elementshcp
    },
    {
      path: '/elementshcpj',
      name: 'Elementshcpj',
      component: Elementshcpj
    },
    {
      path: '/elementshsb',
      name: 'Elementshsb',
      component: Elementshsb
    },
    {
      path: '/elementshtf',
      name: 'Elementshtf',
      component: Elementshtf
    },
    {
      path: '/elementshjz',
      name: 'Elementshjz',
      component: Elementshjz
    },
    {
      path: '/elementshdq',
      name: 'Elementshdq',
      component: Elementshdq
    },
    {
      path: '/elementsssb',
      name: 'Elementsssb',
      component: Elementsssb
    },
    {
      path: '/elementssdq',
      name: 'Elementssdq',
      component: Elementssdq
    },
    {
      path: '/equipment',
      name: 'Equipment',
      component: Equipment
    },
    {
      path: '/equipmentc',
      name: 'Equipmentc',
      component: Equipmentc
    },
    {
      path: '/equipmentx',
      name: 'Equipmentx',
      component: Equipmentx
    },
    {
      path: '/equipmentz',
      name: 'Equipmentz',
      component: Equipmentz
    },
    {
      path: '/wendang',
      name: 'Wendang',
      component: Wendang
    },
    {
      path: '/equipmentzf',
      name: 'Equipmentzf',
      component: Equipmentzf
    },
    {
      path: '/equipmentzk',
      name: 'Equipmentzk',
      component: Equipmentzk
    },
    {
      path: '/equipmentcf',
      name: 'Equipmentcf',
      component: Equipmentcf
    },
    {
      path: '/equipmentck',
      name: 'Equipmentck',
      component: Equipmentck
    },
    {
      path: '/equipmentxf',
      name: 'Equipmentxf',
      component: Equipmentxf
    },
    {
      path: '/equipmentxk',
      name: 'Equipmentxk',
      component: Equipmentxk
    },
    {
      path: '/equipmentw',
      name: 'Equipmentw',
      component: Equipmentw
    },
    {
      path: '/fxweizhi',
      name: 'Fxweizhi',
      component: Fxweizhi
    },
    {
      path: '/fxdingwei',
      name: 'Fxdingwei',
      component: Fxdingwei
    },
    {
      path: '/fxzhibo',
      name: 'Fxzhibo',
      component: Fxzhibo
    },
    {
      path: '/elementdt',
      name: 'Elementdt',
      component: Elementdt
    },
    {
      path: '/elementdtb',
      name: 'Elementdtb',
      component: Elementdtb
    },
    {
      path: '/elementdtsb',
      name: 'Elementdtsb',
      component: Elementdtsb
    },
	{
	  path: '/elementdttui',
	  name: 'Elementdttui',
	  component: Elementdttui
	},
    {
      path: '/elementdtl',
      name: 'Elementdtl',
      component: Elementdtl
    },
    {
      path: '/elementdts',
      name: 'Elementdts',
      component: Elementdts
    },
    {
      path: '/ceshi',
      name: 'Ceshi',
      component: Ceshi
    },
    {
      path: '/elementzx',
      name: 'Elementzx',
      component: Elementzx
    },
    {
      path: '/elementzxdq',
      name: 'Elementzxdq',
      component: Elementzxdq
    },
    {
      path: '/elementfx',
      name: 'Elementfx',
      component: Elementfx
    },
    {
      path: '/elementfxsb',
      name: 'Elementfxsb',
      component: Elementfxsb
    },
    {
      path: '/elementlx',
      name: 'Elementlx',
      component: Elementlx
    },

    {
      path: '/elementzxs',
      name: 'Elementzxs',
      component: Elementzxs
    },
    {
      path: '/elementfxs',
      name: 'Elementfxs',
      component: Elementfxs
    },
    {
      path: '/elementlxs',
      name: 'Elementlxs',
      component: Elementlxs
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/list',
      name: 'List',
      component: List
    },
		{
		  path: '/lable',
		  name: 'Lable',
		  component: Lable
		},
		{
		  path: '/user',
		  name: 'User',
		  component: User
		},
		{
		  path: '/add',
		  name: 'Add',
		  component: Add
		},
		{
		  path: '/test',
		  name: 'Test',
		  component: Test
		},
		{
		  path: '/ac',
		  name: 'Ac',
		  component: Ac
		},
    {
      path: '/acbao',
      name: 'Acbao',
      component: Acbao
    },
    {
      path: '/nac',
      name: 'nAc',
      component: nAc
    },
    {
      path: '/nacbao',
      name: 'nAcbao',
      component: nAcbao
    },
    {
      path: '/acg',
      name: 'Acg',
      component: Acg
    },
    {
      path: '/nacg',
      name: 'Nacg',
      component: Nacg
    },
    {
      path: '/acb',
      name: 'Acb',
      component: Acb
    },
    {
      path: '/ach',
      name: 'Ach',
      component: Ach
    },
    {
      path: '/acj',
      name: 'Acj',
      component: Acj
    },
		{
		  path: '/tj',
		  name: 'Tj',
		  component: Tj
		},
    {
      path: '/tz',
      name: 'Tz',
      component: Tz
    },
    {
      path: '/key',
      name: 'Key',
      component: Key
    },
    {
      path: '/arkey',
      name: 'Arkey',
      component: Arkey
    },
    {
      path: '/nkey',
      name: 'Nkey',
      component: Nkey
    },
    {
      path: '/keyself',
      name: 'Keyself',
      component: Keyself
    },
    {
      path: '/arkeyself',
      name: 'Arkeyself',
      component: Arkeyself
    },
    {
      path: '/nkeyself',
      name: 'Nkeyself',
      component: Nkeyself
    },
    {
      path: '/keys',
      name: 'Keys',
      component: Keys
    },
    {
      path: '/keyo',
      name: 'Keyo',
      component: Keyo
    },
    {
      path: '/arkeyo',
      name: 'Arkeyo',
      component: Arkeyo
    },
    {
      path: '/nkeyo',
      name: 'Nkeyo',
      component: Nkeyo
    },
    {
      path: '/arai',
      name: 'Arai',
      component: Arai
    },
    {
      path: '/ai',
      name: 'Ai',
      component: Ai
    },
    {
      path: '/nai',
      name: 'Nai',
      component: Nai
    },
    {
      path: '/dz',
      name: 'Dz',
      component: Dz
    },
    {
      path: '/ob',
      name: 'Ob',
      component: Ob
    },
    {
      path: '/tui',
      name: 'Tui',
      component:Tui
    },
    {
      path: '/tuic',
      name: 'Tuic',
      component:Tuic
    },
    {
      path: '/mubiao',
      name: 'MuBiao',
      component:MuBiao
    },
    {
      path: '/mubiaok',
      name: 'MuBiaoK',
      component:MuBiaoK
    },
    {
          path: '/mubiaoo',
          name: 'MuBiaoo',
          component:MuBiaoo
    },
    {
          path: '/mubiaot',
          name: 'MuBiaot',
          component:MuBiaot
    },
    {
      path: '/mubiaoko',
      name: 'MuBiaoKo',
      component:MuBiaoKo
    },
    {
      path: '/mubiaokt',
      name: 'MuBiaoKt',
      component:MuBiaoKt
    },
    {
      path: '/armubiao',
      name: 'ArmuBiao',
      component:ArmuBiao
    },
    {
      path: '/armubiaot',
      name: 'ArmuBiaot',
      component:ArmuBiaot
    },
    {
      path: '/armubiaok',
      name: 'ArmuBiaoK',
      component:ArmuBiaoK
    },
    {
      path: '/armubiaokt',
      name: 'ArmuBiaoKt',
      component:ArmuBiaoKt
    },

    {
          path: '/armubiaoo',
          name: 'ArmuBiaoo',
          component:ArmuBiaoo
    },
    {
      path: '/armubiaoko',
      name: 'ArmuBiaoKo',
      component:ArmuBiaoKo
    },
    {
      path: '/tiao',
      name: 'Tiao',
      component:Tiao
    },
    {
      path: '/tiaotwo',
      name: 'TiaoTwo',
      component:TiaoTwo
    },
    {
      path: '/tiaow',
      name: 'Tiaow',
      component:Tiaow
    },
    {
      path: '/tiaowt',
      name: 'Tiaowt',
      component:Tiaowt
    },
    {
      path: '/tiaowtt',
      name: 'Tiaowtt',
      component:Tiaowtt
    },
    {
      path: '/artiaow',
      name: 'Artiaow',
      component:Artiaow
    },
    {
      path: '/artiaowt',
      name: 'Artiaowt',
      component:Artiaowt
    },
    {
      path: '/artiaowtt',
      name: 'Artiaowtt',
      component:Artiaowtt
    },
    {
      path: '/artiao',
      name: 'Artiao',
      component:Artiao
    },
    {
      path: '/artiaotwo',
      name: 'Artiaotwo',
      component:Artiaotwo
    },
    {
      path: '/nmubiao',
      name: 'NmuBiao',
      component:NmuBiao
    },
    {
      path: '/nmubiaok',
      name: 'NmuBiaoK',
      component:NmuBiaoK
    },
    {
          path: '/nmubiaoo',
          name: 'NmuBiaoo',
          component:NmuBiaoo
    },
    {
      path: '/nmuBiaoko',
      name: 'NmuBiaoKo',
      component:NmuBiaoKo
    },
    {
      path: '/ntiao',
      name: 'Ntiao',
      component:Ntiao
    },
    {
      path: '/image',
      name: 'Image',
      component:Image
    },
    {
      path: '/imagex',
      name: 'ImageX',
      component:ImageX
    },
    {
      path: '/imaget',
      name: 'ImageT',
      component:ImageT
    },
    {
      path: '/upload',
      name: 'Upload',
      component:Upload
    },
    {
	      path: '/stui',
	      name: 'STui',
	      component:STui
	    },
     {
         path: '/stime',
         name: 'STime',
         component:STime
       },
       {
           path: '/comge',
           name: 'Comge',
           component:Comge
         },
         {
           path: '/comgf',
           name: 'Comgf',
           component:Comgf
         },






    { path: '*', redirect: '/' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js